import React, { memo } from 'react';

import Spinner from 'react-bootstrap/Spinner';

import i18n from '../messages.json';

/**
 * "Sending..." phase shown after the user clicks Send and before results come back.
 * Just a centered spinner + caption.
 */
const SendingStatus = () => (
  <div className='send-test__status'>
    <Spinner animation='border' role='status' size='lg' />
    <p>{i18n.ink.notification.sendTest.sending}</p>
  </div>
);

export default memo(SendingStatus);
